const getters = {
  sidebar      : state => state.app.sidebar,
  device       : state => state.app.device,
  visitedViews : state => state.tagsView.visitedViews,
  cachedViews  : state => state.tagsView.cachedViews,
  thirdMenuObj : state => state.tagsView.thirdMenuObj,
  currentView  : state => state.tagsView.currentView,
  routes       : state => state.tagsView.routes,
  isLoadRoute  : state => state.tagsView.isLoadRoute,
  structureTree: state => state.power.structureTree,
  pointData    : state => state.power.pointData,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // status: state => state.user.status,
  // roles: state => state.user.roles,
  // setting: state => state.user.setting,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js